import { Container, Modal, Typography } from '@cleartrip/ct-design-components'
import Image from 'next/image'
import { useState } from 'react'

import SmallStar from '@/assets/svg/VDC/SmallStar'
import Star from '@/assets/svg/VDC/Star'
import VdcEducationPage from '@/components/itinerary/Review/VdcBanner/VdcEducationPage/index'
import { TUPLE_COLORS } from '@/components/srp/Tupple/Revamp/config/tupleTheme'

const VDC_REVAMP_PATTERN_URL =
  'https://storage.googleapis.com/offermgmt-prod/offermgmt/images/desktop_revamp/VDC_Pattern.svg'
const VDC_REVAMP_SHIELD_URL =
  'https://storage.googleapis.com/offermgmt-prod/offermgmt/images/desktop_revamp/Vdc_Shield.svg'
const VDC_REVAMP_VERIFIED_ICON_URL =
  'https://storage.googleapis.com/offermgmt-prod/offermgmt/images/desktop_revamp/VDC_VerifiedIcon.svg'

const BANNER_BG = '#F3E8FF'
const TITLE_PURPLE = '#5F1AB6'
const HEADLINE = '#130524'
const FREE_GREEN = '#11A056'
const LEARN_MORE = '#0F6BFF'

const BANNER_CSS = {
  backgroundColor: BANNER_BG,
  border: `1px solid ${TUPLE_COLORS.cardBorder}`,
} as const

const PATTERN_CSS = {
  position: 'absolute',
  left: '50%',
  top: 'calc(50% + 57px)',
  width: 1012,
  height: 620,
  transform: 'translate(-50%, -50%)',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
} as const

const PATTERN_INNER_CSS = {
  transform: 'rotate(-90deg)',
  flex: 'none',
  width: 620,
  height: 1012,
  lineHeight: 0,
} as const

const SHIELD_CSS = {
  position: 'absolute',
  right: 0,
  bottom: 0,
  opacity: 0.1,
  pointerEvents: 'none',
  lineHeight: 0,
} as const

const CONTENT_CSS = {
  padding: '20px',
  rowGap: 8,
  boxSizing: 'border-box',
} as const

const STARS_CSS = {
  position: 'relative',
  width: 28,
  height: 22,
  flexShrink: 0,
  marginLeft: 4,
} as const

function VisaDenialSrpBannerRevamp() {
  const [showPopup, setShowPopup] = useState(false)

  return (
    <Container className='p-relative w-100p o-hidden br-16' css={BANNER_CSS}>
      <Container aria-hidden css={PATTERN_CSS}>
        <Container css={PATTERN_INNER_CSS}>
          <Image alt='' height={1012} src={VDC_REVAMP_PATTERN_URL} width={620} />
        </Container>
      </Container>

      <Container aria-hidden css={SHIELD_CSS}>
        <Image alt='' height={83} src={VDC_REVAMP_SHIELD_URL} width={118} />
      </Container>

      <Container className='p-relative flex flex-column w-100p' css={CONTENT_CSS}>
        <Container className='flex flex-middle flex-between w-100p'>
          <Container className='flex flex-middle' css={{ columnGap: 4 }}>
            <Image alt='' height={20} src={VDC_REVAMP_VERIFIED_ICON_URL} width={20} />
            <Typography colorCode={TITLE_PURPLE} componentNode='p' variant='HM4'>
              Visa Rejection Cover
            </Typography>
          </Container>
          <Typography
            className='c-pointer ws-nowrap'
            colorCode={LEARN_MORE}
            componentNode='span'
            variant='HM4'
            onClick={() => setShowPopup(true)}
          >
            Learn more
          </Typography>
        </Container>

        <Container className='flex flex-middle'>
          <Typography colorCode={HEADLINE} componentNode='p' variant='HM1'>
            Full fare refund if visa gets rejected!
          </Typography>
          <Container aria-hidden css={STARS_CSS}>
            <Container className='p-absolute' style={{ top: 0, left: 2 }}>
              <SmallStar />
            </Container>
            <Container className='p-absolute' style={{ top: 6, left: 10 }}>
              <Star />
            </Container>
          </Container>
        </Container>

        <Typography colorCode={TUPLE_COLORS.heading} componentNode='p' variant='HM4'>
          Absolutely <span style={{ color: FREE_GREEN }}>FREE</span> on Cleartrip.
        </Typography>
      </Container>

      {showPopup && (
        <Modal
          allowBackdropClose
          hideCrossIcon={false}
          modalContentCss={{
            width: '100%',
            borderRadius: '32px 32px 0 0',
            position: 'absolute',
            bottom: 0,
            left: '50%',
            transform: 'translateX(-50%)',
            height: '93vh',
          }}
          open={showPopup}
          onClose={() => setShowPopup(false)}
        >
          <VdcEducationPage onClose={() => setShowPopup(false)} />
        </Modal>
      )}
    </Container>
  )
}

export default VisaDenialSrpBannerRevamp
